import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { useTranslation } from '../../app/LanguageContext';

export default function BoxGeneratorPage() {
  const { translate } = useTranslation();

  return (
    <Box sx={{ maxWidth: 680, mx: 'auto', p: { xs: 2, sm: 3 } }}>
      <Paper
        variant="outlined"
        sx={{
          p: { xs: 3, sm: 5 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: 3,
            bgcolor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.contrastText',
          }}
        >
          <Inventory2OutlinedIcon sx={{ fontSize: 36 }} />
        </Box>

        <Typography variant="h5" fontWeight={600}>
          {translate('extensions.box_generator.name')}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
          {translate('extensions.box_generator.coming_soon_message')}
        </Typography>

        <Box
          component="ul"
          sx={{ textAlign: 'left', color: 'text.secondary', pl: 2.5, mt: 1, mb: 0 }}
        >
          {['extensions.box_generator.feature_1', 'extensions.box_generator.feature_2', 'extensions.box_generator.feature_3'].map((key) => (
            <li key={key}>
              <Typography variant="body2">{translate(key)}</Typography>
            </li>
          ))}
        </Box>

        <Button variant="outlined" disabled sx={{ mt: 1 }}>
          {translate('extensions.box_generator.coming_soon_button')}
        </Button>
      </Paper>
    </Box>
  );
}
